import BaseModel from './BaseModel';

/** Class representing a tag. */
class Tag extends BaseModel {}

export default Tag;
